import React from 'react';
import PropTypes from 'prop-types';
import {TitleBar} from './TitleBar';
import {Canvas} from './Canvas';
import {Wrapper, ScrollMenu, ZoomMenu} from './Controls';
import {Modal} from '@learningblocks/shared-components';
import {useZoomImageHook} from './ZoomImage.utils';
import {Icons} from '@learningblocks/exp-constants';
import style from './style.module.scss';

const {SearchMagnify: SearchSolid} = Icons;

export const ZoomContext = React.createContext(null);

export function ZoomImage(props) {
  return (
    <ZoomContext.Provider value={useZoomImageHook()}>
      <Modal isOpen={props.isOpen} size='md'>
        <>
          <TitleBar title={props.title} close={props.close} />
          <Canvas url={props.url} title={props.title}>
            <Wrapper>
              <ScrollMenu />
              <ZoomMenu />
            </Wrapper>
          </Canvas>
        </>
      </Modal>
    </ZoomContext.Provider>
  );
}

ZoomImage.propTypes = {
  /**
   * Boolean to set if model is open/closed
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Title of the image
   */
  title: PropTypes.string.isRequired,
  /**
   * Url to the image
   */
  url: PropTypes.string.isRequired,
  /**
   * Function to ivoke when you wanna close the component.
   */
  close: PropTypes.func.isRequired,
};

ZoomImage.defaultProps = {
  isOpen: true,
};

export function ZoomImageWrapper(props) {
  const [open, setOpen] = React.useState(false);

  const closeModal = () => setOpen(false);

  const openModal = () => setOpen(true);

  const className = `${style.zoomImageWrapper} ${props.className}`;

  return (
    <>
      <div className={className}>
        {props.children}
        <div
          className={style.zoomImageWrapper_openModalButton}
          role='button'
          tabIndex={0}
          onClick={openModal}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              openModal();
            }
          }}
        >
          <span className={style.zoomImageWrapper_openModalButton_label}>
            Click to Enlarge
          </span>
          <SearchSolid
            style={{fill: 'none'}}
            className={style.zoomImageWrapper_openModalButton_icon}
          />
        </div>
      </div>
      <ZoomImage
        title={props.title}
        url={props.url}
        isOpen={open}
        close={closeModal}
      />
    </>
  );
}

ZoomImageWrapper.propTypes = {
  /**
   * Normal Image Component that render the image
   */
  children: PropTypes.element,
  /**
   * Title of the image
   */
  title: PropTypes.string.isRequired,
  /**
   * Url to the image
   */
  url: PropTypes.string.isRequired,
  /**
   * className
   */
  className: PropTypes.string,
};

ZoomImageWrapper.defaultProps = {
  title: '',
};
